import { render, staticRenderFns } from "./VacationRequestDetails.vue?vue&type=template&id=0d504d34&scoped=true&"
import script from "./VacationRequestDetails.vue?vue&type=script&lang=js&"
export * from "./VacationRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequestDetails.vue?vue&type=style&index=0&id=0d504d34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d504d34",
  null
  
)

export default component.exports